import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { resourceRequest, useResource } from '../../modules/resource/resource'
import * as dialogActions from "../../modules/common/dialog"
import Prepairing from '../common/Prepairing'

const Store = () => {
  const STORE_IMAGE_M = 'STORE_IMAGE_M'
  const STORE_IMAGE_PC = 'STORE_IMAGE_PC'
  const [imagePc, errorPc] = useResource(STORE_IMAGE_PC)
  const [imageM, errorM] = useResource(STORE_IMAGE_M)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(resourceRequest(STORE_IMAGE_PC))
    dispatch(resourceRequest(STORE_IMAGE_M))
  }, [])

  useEffect(() => {
    if (errorPc && errorPc.message) {
      dispatch(dialogActions.alertOpen(errorPc.message))
    }
    if (errorM && errorM.message) {
      dispatch(dialogActions.alertOpen(errorM.message))
    }
  }, [errorPc, errorM])

  const isPrePage = process.env.REACT_APP_IS_PREPAIRING_PAGE

  return (
    <>
      {
        isPrePage === "Y" &&
        <Prepairing />
      }
      {
        isPrePage === "N" &&
        <>
          <div class='img-whole'>
            <img class='pc' src={`${imagePc && imagePc.resource && imagePc.resource.value}`.replace('localhost:8080', 'test.ktwiz.co.kr:17400')} alt="" />
            <img class='m' src={`${imageM && imageM.resource && imageM.resource.value}`.replace('localhost:8080', 'test.ktwiz.co.kr:17400')} alt="" />
          </div>
        </>
      }
    </>
  )
}

export default Store
